import {FETCH_IFTAR_AND_SHERI} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_IFTAR_AND_SHERI:
            return action.payload;
        default:
            return state;
    }
};